import o, { forwardRef as n, isValidElement as m } from "react";
import { isNotEmpty as d, isEmpty as a } from "../../helpers/stringHelper.js";
import { cls as c } from "../../helpers/cls.js";
import { Text as g } from "../Text/Text.js";
import { Check as _, X as b } from "@olxbr/ds-icons";
var h = Object.defineProperty,
  p = Object.defineProperties,
  w = Object.getOwnPropertyDescriptors,
  r = Object.getOwnPropertySymbols,
  f = Object.prototype.hasOwnProperty,
  E = Object.prototype.propertyIsEnumerable,
  i = (e, t, l) => t in e ? h(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: l
  }) : e[t] = l,
  y = (e, t) => {
    for (var l in t || (t = {})) f.call(t, l) && i(e, l, t[l]);
    if (r) for (var l of r(t)) E.call(t, l) && i(e, l, t[l]);
    return e;
  },
  u = (e, t) => p(e, w(t));
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const x = '[ToggleSwitch - Accessibility Error] Um elemento de input deve ter um label associado. Informe pelo menos um dos atributos "label" | "aria-label" | "aria-labelledby" com valor v\xE1lido.',
  v = _ref => {
    let {
      "aria-label": e,
      "aria-labelledby": t,
      label: l
    } = _ref;
    if (!(m(l) || typeof l == "string" && d(l)) && a(e) && a(t)) throw new Error(x);
  },
  s = n((e, t) => (v(e), o.createElement("label", {
    "data-ds-component": "DS-ToggleSwitch",
    className: c("olx-toggle-switch", e.label && "olx-toggle-switch--label-visible", e.disabled && "olx-toggle-switch--disabled", e.className)
  }, e.label && o.createElement(g.BodyMedium, {
    className: "olx-toggle-switch__label"
  }, e.label), o.createElement("input", u(y({
    className: "olx-toggle-switch__native",
    ref: t
  }, e), {
    type: "checkbox"
  })), o.createElement("span", {
    className: "olx-toggle-switch__stylized"
  }, o.createElement("span", {
    className: c("olx-toggle-switch__icon", e.checked && "olx-toggle-switch__icon--checked")
  }), o.createElement(_, {
    className: c("olx-toggle-switch__checked-icon", e.checked && "olx-toggle-switch__checked-icon--checked")
  }), o.createElement(b, {
    className: c("olx-toggle-switch__unchecked-icon", !e.checked && "olx-toggle-switch__unchecked-icon--unchecked")
  })))));
s.displayName = "DS-ToggleSwitch";
export { s as ToggleSwitch };